import { Injectable } from '@angular/core';
import axios, { AxiosResponse } from 'axios';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PhoenixApiService {
  constructor() {}

  async getData(url: string, config?: any): Promise<AxiosResponse<any>> {
    try {
      const fullUrl = `${environment.phoenixURL}${url}`;
      const response = await axios.get(fullUrl, config);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async postData(url: string, data: any, config?: any): Promise<AxiosResponse<any>> {
    try {
      const fullUrl = `${environment.phoenixURL}${url}`;
      const response = await axios.post(fullUrl, data, config);
      return response;
    } catch (error) {
      throw error;
    }
  }
}
